<template>
  <div v-if="status === 'verifying'">
    Please wait
  </div>
  <div v-else-if="status === 'success'">
    <h1>Email address verified</h1>
    <a href="/user_rooms">Go to rooms</a>
  </div>
  <div v-else>An error occurred</div>
</template>

<script>
import {getAuth, applyActionCode} from "firebase/auth";
import apiClient from "../apiClient";

export default {
  name: "HandleVerifyEmail",
  props: ["code", "successToken"],
  data() {
    return {status: "verifying"}
  },
  async mounted() {
    try {
      await applyActionCode(getAuth(), this.code)
      if (this.successToken) await apiClient.post(`/firebase/webhook/user-verified?token=${this.successToken}`)
      this.status = "success"
    } catch (e) {
      this.status = "error"
      console.error(e)
    }
  }
}
</script>

<style scoped>

</style>